/** TextEdit registration: the parser. Render wiring lives in `index.r3f.ts`. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTextEdit } from './parser';
const textEditRegistration = {
    typeName: 'TextEdit',
    parser: parseTextEdit,
};
nodeRegistry.register(textEditRegistration);
//# sourceMappingURL=index.js.map